"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 *
 * @param pageAttrArray
 * @returns {*}
 */
exports.default = function (pageAttrArray) {
    return pageAttrArray.reduce(function (attrProps, _ref) {
        var name = _ref.name,
            value = _ref.value;

        return _extends({}, attrProps, _defineProperty({}, name, value));
    }, {});
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/cmp-prototype-lib/lib/createPageAttrProps.js
// module id = 228
// module chunks = 0